import React from "react";
import BoxShadow from "../../../../../../../Common/Components/BoxShadow";
import { Day, RenderPrice } from "../../../../../../../Common/Function";
import Form from "../Form";
import CardTime from "./Card";

const List = ({ form, setForm, inputs }) => {
  const deleteTime = (_id, day) => {
    let newObj = {};
    if (form.times) {
      Object.keys(form.times).map(day => {
        newObj[day] = [...form.times[day].filter(dd => dd._id != _id)];
      });
    }
    setForm({
      ...form,
      times: newObj,
    });
  };
  return (
    <>
      <BoxShadow style={{ marginTop: "20px", padding: "10px" }}>
        <Form week form={form} inputs={inputs} setForm={setForm} />
      </BoxShadow>

      <div className="row mt-3">
        <div className="col">
          {form.times &&
            !Array.isArray(form.time) &&
            Object.keys(form.times).map((day, kye) => {
              if (
                form.times[day] &&
                Array.isArray(form.times[day]) &&
                form.times[day].length > 0
              ) {
                return (
                  <div key={kye}>
                    <h6>{Day(day)}</h6>
                    <div className="row">
                      {form.times[day].map((time, count) => {
                        return (
                          <CardTime
                            deleteItem={deleteTime}
                            key={count}
                            time={time}
                            options={form.option}
                            day={day}
                          />
                        );
                      })}
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </div>
    </>
  );
};

export default List;
